import InfiniteScroll from "@/components/common/infinitePagination";
import Cards from "@/components/content/cards";
import { useGenreContentList } from "@/helpers/hooks/useGenre";
import { Card, CardBody } from "@nextui-org/react";
import React from "react";
import { GuideType } from "@/helpers/nextPlayGuideHelper";

const FlatGenreScreen = ({ data = { result: {}, contents: [] } }) => {
  const { name, slug } = data.result;
  const { items, hasMore, onLoadMore } = useGenreContentList({
    fetchDelay: 0,
    slug,
    initialPage: 1,
    pageSize: 20,
    autoInit: false,
    initialData: data?.flatData
      ? data.flatData
      : data?.contents?.find((x) => x.key == slug)?.data,
  });

  return (
    <>
      <div className="h-[27vh] flex justify-start items-end md:container mx-auto">
        <h2 className="font-medium sm:font-bold md:font-extrabold lg:font-black text-[#F0F0F0] text-3xl md:text-4xl lg:text-5xl z-10">
          {name}
        </h2>
      </div>
      <div className="w-full min-h-[60vh] md:container mx-auto">
        <div className="my-12 md:my-20">
          {items?.length > 0 ? (
            <InfiniteScroll hasMore={hasMore} loadMore={onLoadMore}>
              <Cards
                items={items?.reduce(
                  (acc, i) =>
                    acc.concat({
                      content: i,
                    }),
                  []
                )}
                isArtist={false}
                noTag={false}
                isMusic={false}
                showTitle={true}
                noMX={true}
                noContainer={true}
                type="movie"
                nextPlayGuide={{
                  type: GuideType.GENRE,
                  slug,
                  name,
                }}
              />
            </InfiniteScroll>
          ) : (
            <div className="w-full flex justify-center items-center pt-16">
              <Card className="dark px-24 py-5">
                <CardBody>
                  <span className="font-extrabold xs:text-lg sm:text-xl md:text-2xl text-[#BFBFBF]">
                    محتوایی یافت نشد.
                  </span>
                </CardBody>
              </Card>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default FlatGenreScreen;
